<template>
    <v-layout wrap class="fill-height" justify-center align-center>
        <v-flex xs12>
            <v-card>
                <v-toolbar color="secondary-card darken-1" flat>

                    <v-toolbar-title>{{title}}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-text-field
                            v-model="search"
                            class="hidden-xs-only mr-2"
                            placeholder="buscar"
                            style="max-width: 200px"
                            prepend-inner-icon="search"
                            clearable/>

                    <div class="hidden-sm-and-down" >
                        <v-btn small color="primary" class="ma-1" @click="selectAll">
                            Todos
                            <v-icon size="12" right >fas fa-check-double</v-icon>
                        </v-btn>
                        <v-btn small color="accent" class="ma-1"  @click="selectNone">
                            Ninguno
                            <v-icon size="12" right>fas fa-minus</v-icon>
                        </v-btn>
                    </div>

                    <div class="hidden-md-and-up" >
                        <v-btn small fab color="primary" @click="selectAll">
                            <v-icon size="12"  >fas fa-check-double</v-icon>
                        </v-btn>
                        <v-btn small fab color="accent" @click="selectNone">
                            <v-icon size="12" >fas fa-minus</v-icon>
                        </v-btn>
                    </div>

                </v-toolbar>

                <div class="caption">

                </div>

                <v-list style="overflow-y: auto; max-height: 300px">

                    <template v-for="item in items">
                        <v-list-item
                                :key="item.id"
                                :dark="item.isAttached"
                                :class="[{'primary': item.isAttached}, {'white--text': item.isAttached}]"

                                @click="toggleOne(item)"
                        >
                            <v-list-item-avatar>
                                <v-icon>{{ item.type === 'exam' ? 'fas fa-file-prescription' : 'fa-user-md' }}</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title>{{ item.description }}</v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action v-if="item.isAttached">
                                <v-btn icon ripple>
                                    <v-icon color="white">fa-check</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-divider ></v-divider>

                    </template>

                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>
<script>

    import {debounce} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'

    import {mapState} from 'vuex'

    export default{
        props: ['services', 'title'],
        data(){
            return {
                loadingSync: false,
                search: '',
                selected: []
            }
        },
        async mounted(){
            var vm = this
            await this.loadAttached()
            vm.selected = vm.providerServices.map(service => service.serviceItemId)
        },
        methods: {
            selectAll(){
                var vm = this
                vm.selected = [...new Set(
                    vm.providerServices
                        .map(serv => serv.serviceItemId)
                        .concat(
                            vm.services.map(serv => serv.id)
                        )
                )]
            },
            selectNone(){
                var vm = this
                vm.selected =  vm.providerServices
                        .filter(service => service.type !== vm.type )
                        .map(service => service.serviceItemId)
            },
            toggleOne(item){
                var vm = this
                const foundIndex = vm.selected.findIndex(id => {
                    return id === item.id
                })
                if(foundIndex === -1){
                    vm.selected.push(item.id)
                }else{
                    vm.selected.splice(foundIndex, 1)
                }
            },
            async loadAttached(){
                var vm = this
                await vm.$store.dispatch('services/loadProviderServices')
            },
            debouncedSync: debounce(function(){
                this.syncData()
            }, 300),
            async syncData(){

                var vm = this
                if(vm.loadingSync || !vm.currentProvider) return

                vm.loadingSync = true
                const response = await ApiUtils.makePost(`provider/${vm.currentProvider.id}/service/items/sync`, {
                    service_item_ids: vm.selected.length > 0 ? vm.selected : []
                })
                vm.loadingSync = false

                if(response.ok){
                    vm.loadAttached()
                }

            }
        },
        computed: {
                ...mapState(['currentProvider']),
            items(){
                var vm = this
                const services = this.services.map(service =>  {
                    service.isAttached = vm.selected.includes(service.id)
                    return service
                })

                return vm.search ? services.filter(serv => {
                    return serv.description.toLowerCase()
                            .includes(vm.search.toLowerCase())
                }) : services

            },
            providerServices(){
                return this.$store.getters['services/providerServices']
            },
            type(){
                return this.services && this.services.length > 0 ?
                        this.services[0].type : 'other'
            }
        },
        watch: {
            selected(val){
                this.debouncedSync()
            }
        }
    }
</script>
